const Display = () => {
  return '';
};

export default Display;
